const classicMethods = [
  { name: 'Веревочные курсы', problem: 'Физические упражнения, не связанные с рабочими задачами. Участники возвращаются к тем же конфликтам.' },
  { name: 'Квесты', problem: 'Развлечение, которое не меняет реальных отношений и правил взаимодействия в офисе.' },
  { name: 'Пейнтбол', problem: 'Агрессия и соревнование могут усилить конфликты, а не решить их.' },
  { name: 'Боулинг', problem: 'Приятный вечер, но ноль влияния на бизнес-процессы и культуру.' },
  { name: 'Картинг', problem: 'Соревновательный драйв без связи с командной работой и ответственностью.' },
  { name: 'Корпоративы', problem: 'Хорошее настроение на пару дней, затем — полное возвращение к статус-кво.' },
];

const realChanges = [
  { icon: 'ri-heart-pulse-line', title: 'Отношения', desc: 'Люди начинают видеть друг в друге партнеров, а не конкурентов' },
  { icon: 'ri-settings-4-line', title: 'Правила взаимодействия', desc: 'Команда вырабатывает общие нормы коммуникации и принятия решений' },
  { icon: 'ri-shield-star-line', title: 'Ценности', desc: 'Формируются общие ценности, на которые опирается команда' },
  { icon: 'ri-chat-smile-2-line', title: 'Способы коммуникации', desc: 'Открытый диалог заменяет обвинения и молчание' },
  { icon: 'ri-user-star-line', title: 'Ответственность', desc: 'Каждый берет на себя ответственность за общий результат' },
  { icon: 'ri-community-line', title: 'Культура', desc: 'Формируется здоровая корпоративная культура' },
];

export default function WhyClassicTeamBuildingFails() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему классический тимбилдинг почти не работает
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Многие компании тратят бюджет на развлечения и удивляются: почему через неделю ничего не изменилось? Вот почему.
        </p>

        {/* Таблица проблем классических методов */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-red-50 rounded-2xl p-8 border border-red-100">
            <h3 className="text-xl font-bold text-red-800 mb-6 text-center">
              Классические методы: что происходит на самом деле
            </h3>
            <div className="space-y-4">
              {classicMethods.map((m, i) => (
                <div key={i} className="bg-white rounded-xl p-5 border border-red-100 flex items-start gap-4">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-close-line text-xl text-red-500"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">{m.name}</h4>
                    <p className="text-gray-600 text-sm mt-1">{m.problem}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <p className="text-xl text-center text-gray-700 leading-relaxed">
            Почему после корпоратива или квеста <strong className="text-gray-900">через неделю ничего не меняется?</strong> Потому что эти мероприятия не работают с причинами проблем — они просто создают временное хорошее настроение.
          </p>
        </div>

        {/* Что реально меняет командообразование */}
        <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 md:p-12 border border-teal-100">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-4">
            Настоящее командообразование меняет
          </h3>
          <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
            Вот чем отличается профессиональное командообразование от развлечения. Оно работает с глубинными процессами внутри команды.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {realChanges.map((item, i) => (
              <div key={i} className="bg-white rounded-xl p-6 border border-teal-100 hover:border-teal-300 transition-colors">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-xl text-white`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}